import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import { runInAction, toJS } from 'mobx';
import MatchOddsInternationalsModel from './model/internationals';
import { ScoreDetailService } from '../../../../../../common/services';

const MatchOddsStore = (type) => {
  const store = useLocalStore(() => ({
    internationals: [],
    loading: false,
    init: false,
    gameId: null,
    async getOddsSites(gameId) {
      store.loading = true;

      const result = await ScoreDetailService.getOddsSites(gameId);

      return result;
    },
    getAll: async (gameId) => {
      store.loading = true;

      const [international] = await Promise.all([store.getOddsSites(gameId)]);

      runInAction(() => {
        store.internationals = international.map(
          (item) => new MatchOddsInternationalsModel(item)
        );

        store.loading = false;
      });
    },
    get getInternationalOptions() {
      const { internationals } = store;

      let result = { handicap: '', unover: '' };

      if (internationals.length > 0) {
        if (internationals[0].oddsList.handicapOdds.length > 0) {
          result.handicap = `H ${internationals[0].oddsList.handicapOdds[0].optionValue}`;
        }

        if (internationals[0].oddsList.underOverOdds.length > 0) {
          result.unover = `U/O ${internationals[0].oddsList.underOverOdds[0].optionValue}`;
        }
      }

      return result;
    }
  }));

  return {
    getAll: store.getAll,
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        internationals: store.internationals,
        important: store.important,
        getInternationalOptions: store.getInternationalOptions
      };
    })
  };
};

export default MatchOddsStore;
